// extracted by mini-css-extract-plugin
module.exports = {"heading":"index-module__heading___qdaiq","evolved":"index-module__evolved___3fs8y"};